import {versaoGitFiltrada} from 'src/utils'

let baseUrl

if (process.env.VUE_APP_K8s) {
  let namespace = window.location.pathname
  namespace = namespace[namespace.length - 1] === '/' ? namespace.slice(0, namespace.length - 1) : namespace
  namespace = namespace.split('/new-web')[0] + '/back'
  baseUrl = `${window.location.origin}${namespace}`
} else {
  baseUrl = `${process.env.VUE_APP_API_URL}`
}

const versao = versaoGitFiltrada(process.env.VUE_APP_TAG_VERSION)

const config = {
  baseUrl,
  herokuUrl: `${process.env.VUE_APP_HEROKU_URL}`,
  newHerokuUrl: `${process.env.VUE_APP_NEW_HEROKU_URL}`,
  version: versao
}

export default config
